import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Tag } from 'antd';
import Translate from 'react-translate-component';

import { mapIndexed } from 'utils/ramdaAdditions';
import { openModalDocument } from 'actions/modalActions';
import { ContentMessage } from 'components/common/fields/ContentMessage';
import CustomIcon from 'components/common/CustomIcon';

@connect(null, { openModalDocument })
export default class DocumentList extends Component {
    static propTypes = {
        openModalDocument: PropTypes.func,
        documents: PropTypes.array,
        metro: PropTypes.number,
    };

    render() {
        const { documents = [], metro, openModalDocument } = this.props;

        return (
            <div className="panel-view files-list">
                { mapIndexed((doc, index) => (
                    <div className="ant-row" key={index}>
                        <Col span={18} className="left-side">
                            <a className="title" onClick={() => openModalDocument(metro ? { metro, ...doc} : doc)}>
                                {doc.name}
                                { doc.fileType && (
                                    <Tag color="blue">
                                        {doc.fileType}
                                    </Tag>
                                )}
                                <br/>
                                <small className="lv-small">
                                    { doc.creatorName }
                                </small>
                            </a>
                        </Col>
                        { doc.date && (
                            <Col span={6} className="right-side text-right">
                                <span className="date">
                                    <CustomIcon type="calendar-o" />
                                    { doc.date }
                                </span>
                            </Col>
                        )}
                    </div>
                ), documents)}
                <ContentMessage show={documents.length === 0} message={<Translate content="documents.no_data" />} />
            </div>
        );
    }
}
